import { formatCurrency, formatDate } from '@if/core/utils'
import { GridColDef } from '@mui/x-data-grid'
import { InteracWire } from '@src/types/interac'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useDeletedInteracWireColumns = (): GridColDef<InteracWire>[] => {
  const { t } = useTranslation()

  return useMemo<GridColDef<InteracWire>[]>(
    () => [
      {
        field: 'receivedOn',
        headerName: t('common.date'),
        sortable: false,
        minWidth: 130,
        disableColumnMenu: true,
        valueFormatter: (receivedOn: Date) => {
          if (receivedOn.toString() === '0001-01-01T00:00:00') return ''
          return formatDate(receivedOn)
        },
      },
      {
        field: 'amount',
        headerName: t('interacWire.amount'),
        sortable: false,
        align: 'right',
        disableColumnMenu: true,
        valueFormatter: formatCurrency,
      },
      {
        field: 'sentBy',
        headerName: t('interacWire.from'),
        flex: 1,
        sortable: false,
        disableColumnMenu: true,
        valueGetter: (_value, row) => `${row.sentBy} (${row.senderEmail})`,
      },
      {
        field: 'message',
        headerName: t('interacWire.message'),
        flex: 1,
        sortable: false,
        disableColumnMenu: true,
      },
      {
        field: 'discardedBy',
        headerName: t('interacHistory.discardedBy'),
        minWidth: 150,
        sortable: false,
        disableColumnMenu: true,
      },
      {
        field: 'discardedOn',
        headerName: t('interacHistory.discardedOn'),
        minWidth: 130,
        sortable: false,
        disableColumnMenu: true,
        valueFormatter: (discardedOn: Date) => {
          if (!discardedOn) return ''
          return formatDate(discardedOn)
        },
      },
      {
        field: 'discardReason',
        headerName: t('interacHistory.discardReason'),
        flex: 1,
        sortable: false,
        disableColumnMenu: true,
      },
    ],
    [t],
  )
}
